import { render } from "./Radio.vue?vue&type=template&id=284492d5"
import script from "./Radio.vue?vue&type=script&lang=ts"
export * from "./Radio.vue?vue&type=script&lang=ts"
script.render = render

export default script